import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getResellerAvailableCatalogs } from 'core/use-cases/catalog/slice/actions';
import { starlinkContentFetch } from 'core/use-cases/content/slice/actions';
import { useContentCycleGuide } from 'core/use-cases/content/hooks';
import ShareGuideCycle from 'ui/components/templates/ShareGuideCycle/ShareGuideCycle';
import config from 'config';
import { CycleGuideBot, CycleGuideEud } from './components';
import type { ResellerAvailableCatalogs } from 'core/services/bff';

const CycleGuide = () => {
  const { filterCurrentCycleGuides } = useContentCycleGuide();
  const [openShareModal, setOpenShareModal] = useState(false);
  const [selectedGuide, setSelectedGuide] = useState<ResellerAvailableCatalogs>(
    {} as unknown as ResellerAvailableCatalogs,
  );
  const dispatch = useDispatch();
  const commonProps = {
    catalogs: filterCurrentCycleGuides,
    setOpenShareModal,
    setSelectedGuide,
  };

  const templates = {
    eud: <CycleGuideEud {...commonProps} />,
    bot: <CycleGuideBot {...commonProps} />,
  } as { [key: string]: JSX.Element };

  useEffect(() => {
    dispatch(getResellerAvailableCatalogs.request());
    dispatch(starlinkContentFetch.request({ document: 'collection_catalogs' }));
  }, []);

  return (
    <div data-testid="cycle-guide">
      <ShareGuideCycle
        open={openShareModal}
        clickCloseShareModal={() => setOpenShareModal(false)}
        selectedGuide={selectedGuide}
      />
      {filterCurrentCycleGuides.length > 0 ? <>{templates[config.app.short]}</> : <></>}
    </div>
  );
};

export default CycleGuide;
